/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { FinancialReportResponse } from '../models/FinancialReportResponse';
import type { FinancialSummary } from '../models/FinancialSummary';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class FinanceService {

    /**
     * API to get financial summary
     * @returns FinancialSummary Success
     * @throws ApiError
     */
    public static financeGetFinancialSummary(): CancelablePromise<FinancialSummary> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/finance/summary',
            errors: {
                400: `Bad Request`,
                500: `Server Error`,
            },
        });
    }

    /**
     * API to get financial report list with pagination and filters
     * @param page Page number (default 1)
     * @param limit Number of items per page (default 10)
     * @param searchInput Search by payer name or email
     * @param paymentStatus Filter by payment status (Paid/Unpaid)
     * @param payerType Filter by payer type (Coach/Rider/Team)
     * @returns FinancialReportResponse Success
     * @throws ApiError
     */
    public static financeGetFinancialReportList(
        page: number = 1,
        limit: number = 10,
        searchInput?: string,
        paymentStatus?: string,
        payerType?: string,
    ): CancelablePromise<FinancialReportResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/finance/finance-report/list',
            query: {
                'page': page,
                'limit': limit,
                'searchInput': searchInput,
                'paymentStatus': paymentStatus,
                'payerType': payerType,
            },
            errors: {
                400: `Bad Request`,
                500: `Server Error`,
            },
        });
    }

    /**
     * API to export financial report list as CSV for Excel download (no pagination)
     * Filters are the same as GetFinancialReportList but returns a CSV file.
     * @param searchInput
     * @param paymentStatus
     * @param payerType
     * @returns any Success
     * @throws ApiError
     */
    public static financeExportFinancialReportList(
        searchInput?: string,
        paymentStatus?: string,
        payerType?: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/finance/finance-report/export',
            query: {
                'searchInput': searchInput,
                'paymentStatus': paymentStatus,
                'payerType': payerType,
            },
            errors: {
                400: `Bad Request`,
                500: `Server Error`,
            },
        });
    }

}
